const isLocalhost = false;
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
const restApiUrl = isLocalhost
  ? 'https://localhost:5001/api'
  : 'https://dev-viatracks-api.azurewebsites.net/api';

export const environment = {
  auth: {
    issuer: 'https://connect-stage.devinco.com',
  },
  endpoints: {
    restApi: restApiUrl,
    statisticsApi: 'https://dev-viatracks-statistics-api.azurewebsites.net/api',
    progressHubApi: 'https://dev-viatracks-api.azurewebsites.net/progressHub',
    publicHubApi: 'https://dev-viatracks-api.azurewebsites.net/publicHub',
  },
  mapRefreshInterval: 30000,
  snackBarDisplayTime: 2000,
  production: false,
  leafletApiKey: 'a9cae192-8738-472d-8309-5f7f7bc6e47f',
  vismaExpenseUrlBase:
    'https://expense.stag.visma.net/expenseapi/oauth/authorize',
  buildNumber: '#{ViaTracks.BuildNumber}#',
};
